import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetStartedComponent } from './get-started.component';
// import { GetstartedComponent } from '../get-started/getstarted/getstarted.component';
import { HeaderComponent } from '../get-started/header/header.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GetStartedComponent ,HeaderComponent]
})
export class GetStartedModule { }
